import { render, staticRenderFns } from "./CourseApplicationViewer.vue?vue&type=template&id=7bcd8bc1"
import script from "./CourseApplicationViewer.vue?vue&type=script&lang=js"
export * from "./CourseApplicationViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports